import { render } from "./tableinfo.html?vue&type=template&id=48297dd8&scoped=true&external"
import script from "./tableinfo.ts?vue&type=script&lang=js&external"
export * from "./tableinfo.ts?vue&type=script&lang=js&external"

import "./tableinfo.scss?vue&type=style&index=0&id=48297dd8&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48297dd8"],['__file',"src/components/ui/tableinfo/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48297dd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48297dd8', __exports__)) {
    api.reload('48297dd8', __exports__)
  }
  
  module.hot.accept("./tableinfo.html?vue&type=template&id=48297dd8&scoped=true&external", () => {
    api.rerender('48297dd8', render)
  })

}


export default __exports__